export default __webpack_public_path__ + "static/media/benefit-1@2x.b2ff2e4b.png";